import React from "react";

import { CONTENT_MAX_WIDTH_STYLE } from "@/src/constants/size";

import type { JSX, ReactNode } from "react";

interface BulkPageLayoutProps {
  children: ReactNode;
}

function BulkPageLayout({ children }: BulkPageLayoutProps): JSX.Element {
  return (
    <div className="flex size-full flex-col overflow-auto p-7.5">
      <div
        className="mx-auto flex w-full max-w-(--maxWidth) flex-1 flex-col"
        style={CONTENT_MAX_WIDTH_STYLE}
      >
        {children}
      </div>
    </div>
  );
}

export default BulkPageLayout;
